module.exports = __webpack_public_path__ + "img/twitter.f2842278.svg";